import React from 'react';

import { MarketplaceSaleChannelType } from '@anyx/common-graphql';

const ShopifyAddPage = React.lazy(() =>
  import('./pages/add').then((module) => ({ default: module.ShopifyAddPage }))
);

const ShopifyEditPage = React.lazy(() =>
  import('./pages/edit').then((module) => ({ default: module.ShopifyEditPage }))
);

const ShopifyTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.ShopifyTemplate }))
);

export const shopifyRouting = [
  {
    path: MarketplaceSaleChannelType.Shopify,
    element: <ShopifyTemplate />,
    children: [
      {
        index: true,
        element: <ShopifyAddPage />,
      },
      {
        path: ':channelId',
        children: [
          {
            index: true,
            element: <ShopifyEditPage />,
          },
        ],
      },
    ],
  },
];
